import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Loader from "./components/Loader";
import FinanceGridFinance from "./components/Finance Grid Finance/FinanceGridFinance";
import FinanceGrid from "./components/Finance Grid Operations/FinanceGrid";
import FinanceGridView from "./components/Finance Grid Finance/FinanceGridView";
import OperationsGridView from "./components/Finance Grid Operations/OperationsGridView";
import OperationsGrids from "./components/Finance Grid Operations/OperationsGrids";
import Dashboard from "./components/Pre-Order-Components/Dashboard";
import PreOrderInsider from "./components/Pre-Order-Components/PreOrderInsider";
import Login from "./components/Login/login";
import RetailLedDistributors from "./components/Retail Led Distributors/retailorder";
import GridSingle from "./components/Retail Led Distributors/grid";
import ViewGridSingle from "./components/Retail Led Distributors/ViewGrid";
import SettlementTracker from "./components/Settlement Tracker/settlementTracker";
import FileUploader from "./components/Pre-Order-Components/FileUploader";
import { List1 } from "./components/Pre-Order-Components/List1";
import { List2 } from "./components/Pre-Order-Components/List2";
import MilkSettlement from "./components/Milk Settlement Tracker/MilkSettlement";
import PlatformCharges from "./components/PlatformChargesOperations";
import Provisions from "./components/Provisions";
import RevoleTracker from "./components/Settlement Tracker/RevoleTracker";
import EditProvision from "./Assets/Images/Edit Provision/EditProvision";
import Oms from "./components/OMS/Oms";
import Inventory from "./components/OMS/Inventory";
import View from "./components/OMS/View";
import OrdersWithLimitBreached from "./components/Finance Grid Operations/ordersWithLimitBreached";
import FinanceBreachedGrids from "./components/Finance Grid Operations/FinanceBreachedGrids";
import HOC from "./components/HOC";
import FinanceLimitBreachedGridView from "./components/Finance Grid Operations/FinanceLimitBreachedGridView";
import "./index.css";
import AyekartAgroOrders from "./components/AyekartAgro/ayekartAgroOrders";
import AyekartAgroGrids from "./components/AyekartAgro/ayekartAgroGrids";
import AyekartAgroLimitBreachedOrders from "./components/AyekartAgro/ayekartAgroLimitBreachedOrders";
import AyekartAgroLimitBreachedGrids from "./components/AyekartAgro/ayekartAgroLimitBreachedGrids";
import AyekartRetailOrders from "./components/AyekartRetail/ayekartRetailOrders";
import AyekartRetailLimitBreachedOrders from "./components/AyekartRetail/ayekartRetailLimitBreachedOrders";
import AyekartRetailGrids from "./components/AyekartRetail/ayekartRetailGrids";
import AyekartRetailLimitBreachedGrids from "./components/AyekartRetail/ayekartRetailLimitBreachedGrids";
import OperationsAyekartAgroGridView from "./components/AyekartAgro/OperationsAyekartAgroGridView";
import OperationsAyekartRetailGridView from "./components/AyekartRetail/OperationsAyekartRetailGridView";
import AyekartAgroLimitBreachedGridView from "./components/AyekartAgro/ayekartAgroLimitBreachedGridView";
import AyekartRetailLimitBreachedGridView from "./components/AyekartRetail/ayekartRetailLimitBreachedGridView";
import AyekartRetailWD from "./components/AyekartRetail/ayekartRetailWDOrders";
import AyekartRetailWDGrids from "./components/AyekartRetail/ayekartRetailWDGrids";
import OperationsAyekartRetailWDGridView from "./components/AyekartRetail/OperationsAyekartRetailWDGridView";
import AyekartFintechOrders from "./components/AyekartFintech/ayekartFintechOrders";
import AyekartFintechGrids from "./components/AyekartFintech/ayekartFintechGrids";
import AyekartFintechGridView from "./components/AyekartFintech/ayekartFintechGridView";
import AyekartFintechFinanceGrids from "./components/AyekartFintech/ayekartFintechFinanceGrids";
import AyekartFintechFinanceGridView from "./components/AyekartFintech/ayekartFintechFinanceGridView";
import AyekartAgroFinanceGridView from "./components/AyekartAgro/ayekartAgroFinanceGridView";
import AyekartAgroFinanceGrids from "./components/AyekartAgro/AyekartAgroFinanceGrids";
import AyekartRetailFinanceGrids from "./components/AyekartRetail/AyekartRetailFinanceGrids";
import AyekartRetailFinanceGridView from "./components/AyekartRetail/ayekartRetailFinanceGridView";
import AyekartRetailWDFinanceGrids from "./components/AyekartRetail/ayekartRetailWDFinanceGrids";
import AyekartRetailWDFinanceGridView from "./components/AyekartRetail/AyekartRetailWDFinanceGridView";
import AyekartRetailAdvancePO_Orders from "./components/AyekartRetail/ayekartRetailAdvancePO_Orders";
import AyekartRetailAdvancePOGrids from "./components/AyekartRetail/ayekartRetailAdvancePOGrids";
import OperationsAyekartRetailAdvancePOGridView from "./components/AyekartRetail/OperationsAyekartRetailAdvancePOGridView";
import AyekartRetailAdvancePOFinanceGrids from "./components/AyekartRetail/ayekartRetailAdvancePOFinanceGrids";
import AyekartRetailAdvancePOFinanceGridView from "./components/AyekartRetail/ayekartRetailAdvancePOFinanceGridView";
import AyekartAgroFNVOrders from "./components/AyekartAgro/AyekartAgroFNVOrders";
import AyekartAgroFNVGrids from "./components/AyekartAgro/AyekartAgroFNVGrids";
import OperationsAyekartAgroFNVGridView from "./components/AyekartAgro/OperationsAyekartAgroFNVGridView";
import AyekartAgroFNVFinanceGrids from "./components/AyekartAgro/AyekartAgroFNVFinanceGrids";
import AyekartAgroFNVFinanceGridView from "./components/AyekartAgro/AyekartAgroFNVFinanceGridView";

function App() {
  return (
    <div className="App ">
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<HOC />}>
              <Route path="/oms" element={<Oms />} />
              <Route path="/oms/inventory" element={<Inventory />} />
              <Route path="/oms/:id" element={<View />} />
              <Route path="/bulkorder" element={<Navigate to="/" replace />} />

              {/* Ayekart Fintech */}
              <Route path="/ayekart-fintech/orders" element={<AyekartFintechOrders />} />
              <Route path="/ayekart-fintech/grids" element={<AyekartFintechGrids />} />
              <Route path="/ayekart-fintech/grid-view" element={<AyekartFintechGridView />} />
              <Route path="/ayekart-fintech/finance-grids" element={<AyekartFintechFinanceGrids />} />
              <Route path="/ayekart-fintech/finance-grid-view" element={<AyekartFintechFinanceGridView />} />
              {/*  */}
              <Route path="/ayekart-fintech/orders-with-limit-breached" element={<OrdersWithLimitBreached />} />
              <Route path="/ayekart-fintech/limit-breached-grids" element={<FinanceBreachedGrids />} />
              <Route path="/ayekart-fintech/limit-breached-grids/grid-view" element={<FinanceLimitBreachedGridView />} />
              <Route path="/operations/ayekart-fintech/grid-view" element={<OperationsGridView />} />
              {/* Ayekart Fintech Ends */}

              <Route path="/finance-grid-view" element={<FinanceGridView />} />
              <Route path="/operations/finance-grid" element={<OperationsGrids />} />
              <Route path="/operations/grid-view" element={<OperationsGridView />} />

              {/* Ayekart Agro -orders & grids */}
              <Route path="/ayekart-agro/orders" element={<AyekartAgroOrders />} />
              <Route path="/ayekart-agro/grids" element={<AyekartAgroGrids />} />
              <Route path="/ayekart-agro/grid-view" element={<OperationsAyekartAgroGridView />} />
              <Route path="/ayekart-agro/finance-grids" element={<AyekartAgroFinanceGrids />} />
              <Route path="/ayekart-agro/finance-grid-view" element={<AyekartAgroFinanceGridView />} />
              <Route path="/ayekart-agro/orders-with-limit-breached" element={<AyekartAgroLimitBreachedOrders />} />
              <Route path="/ayekart-agro/limit-breached-grids" element={<AyekartAgroLimitBreachedGrids />} />
              <Route path="/ayekart-agro/limit-breached-grids/grid-view" element={<AyekartAgroLimitBreachedGridView />} />

              {/* Ayekart Agro -FNV orders & grids */}

              <Route path="/ayekart-agro/fnv/orders" element={<AyekartAgroFNVOrders />} />
              <Route path="/ayekart-agro/fnv/grids" element={<AyekartAgroFNVGrids />} />
              <Route path="/ayekart-agro/fnv/grid-view" element={<OperationsAyekartAgroFNVGridView />} />
              <Route path="/ayekart-agro/fnv/finance-grids" element={<AyekartAgroFNVFinanceGrids />} />
              <Route path="/ayekart-agro/fnv/finance-grid-view" element={<AyekartAgroFNVFinanceGridView />} />


              {/* Ayekart Agro -orders & grids Ends*/}

              {/* Ayekart retail -orders & grids */}
              <Route path="/ayekart-retail/orders" element={<AyekartRetailOrders />} />
              <Route path="/ayekart-retail/orders-with-limit-breached" element={<AyekartRetailLimitBreachedOrders />} />
              <Route path="/ayekart-retail/grids" element={<AyekartRetailGrids />} />
              <Route path="/ayekart-retail/grid-view" element={<OperationsAyekartRetailGridView />} />
              <Route path="/ayekart-retail/finance-grids" element={<AyekartRetailFinanceGrids />} />
              <Route path="/ayekart-retail/finance-grid-view" element={<AyekartRetailFinanceGridView />} />
              <Route path="/ayekart-retail/limit-breached-grids" element={<AyekartRetailLimitBreachedGrids />} />
              <Route path="/ayekart-retail/limit-breached-grids/grid-view" element={<AyekartRetailLimitBreachedGridView />} />
              <Route path="/ayekart-retail/advance-wholesale-distribution" element={<AyekartRetailWD />} />
              <Route path="/ayekart-retail/advance-wholesale-distribution/grids" element={<AyekartRetailWDGrids />} />
              <Route path="/ayekart-retail/advance-wholesale-distribution/grid-view" element={<OperationsAyekartRetailWDGridView />} />
              <Route path="/ayekart-retail/advance-wholesale-distribution/finance-grids" element={<AyekartRetailWDFinanceGrids />} />
              <Route path="/ayekart-retail/advance-wholesale-distribution/finance-grid-view" element={<AyekartRetailWDFinanceGridView />} />

              {/* Retail Advance PO */}
              <Route path="/ayekart-retail/advance-PO" element={<AyekartRetailAdvancePO_Orders />} />
              <Route path="/ayekart-retail/advance-PO/grids" element={<AyekartRetailAdvancePOGrids />} />
              <Route path="/ayekart-retail/advance-PO/grid-view" element={<OperationsAyekartRetailAdvancePOGridView />} />
              <Route path="/ayekart-retail/advance-PO/finance-grids" element={<AyekartRetailAdvancePOFinanceGrids />} />
              <Route path="/ayekart-retail/advance-PO/finance-grid-view" element={<AyekartRetailAdvancePOFinanceGridView />} />
              {/* Ayekart retail -orders & grids Ends*/}

              <Route path="/pre-order-list/Upload" element={<FileUploader />} />
              <Route path="/pre-order-list" element={<Dashboard />} />
              <Route path="/pre-order-list/Batch/:batch_id" element={<PreOrderInsider />} />
              <Route path="/List1" element={<List1 />} />
              <Route path="/final-orders" element={<List2 />} />
              <Route path="/distributors-lead-retail" element={<RetailLedDistributors />} />
              <Route path="/settlement-tracker" element={<SettlementTracker />} />
              <Route path="/settlement-milk-tracker" element={<MilkSettlement />} />
              <Route path="/revoke-tracker" element={<RevoleTracker />} />
              <Route path="/distributors-lead-retail/grid/:grid_id" element={<GridSingle />} />
              <Route path="/distributors-lead-retail/view-grid/:grid_id" element={<ViewGridSingle />} />
              <Route path="/Operations/platform-charges" element={<PlatformCharges />} />
              <Route path="/finance-provisions" element={<Provisions />} />
              <Route path="/edit-finance-provision" element={<EditProvision />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
